// Packages
import tw, { styled, css } from 'twin.macro'

// Images
import LogoAsset from '../../_images/amex.svg'
import BackgroundFlourish from '../../_images/main-background-flourish.svg'

// Modal mask
export const ModalMask = styled.div(() => [
  `background-color: rgba(0,0,0,0.5);`,
  tw`absolute w-full h-full z-40`,
])

export const Logo = styled.div(() => [
  `width:150px; height:41px; left: 20px; top: 32px; background-image: url("${LogoAsset}");`,
  tw`absolute z-10`,
])

export const Main = styled.main(() => [
  `background-color:#404143;`,
  `@media screen and (min-width: 768px)`,
  tw`relative min-h-screen overflow-x-hidden bg-[#F7F8F9]`,
])

export const Flourish = styled.div(() => [
  `aspect-ratio: 1 / 5; background-image: url("${BackgroundFlourish}");`,
  tw`absolute w-1/3 top-[660px] md:top-[460px] lg:top-[560px] bg-no-repeat bg-contain`,
])

export const Container = styled.div(() => [
  ``,
  tw`max-w-5xl mx-auto px-4 relative z-10`,
])

const introContent = css`
  p + p {
    margin-top: 1em;
  }
`

export const ControlsBox = styled.div(() => [
  tw`relative bg-gray-100 rounded-lg p-6 mt-6 border-gray-200 border`,
])

export const ControlsClearLink = styled.button(() => [
  // Positioned inline with the search/postcode field labels (top of the box).
  `position: absolute; top: 24px; right: 24px;`,
  `
  :focus {
    outline: 1px dashed #006FCF;
    outline-offset: 2px;
  }
  `,
  tw`text-[#006FCF] text-sm font-medium cursor-pointer`,
])

export const Checkbox = styled.div(() => [
  ``,
  tw`text-copy text-white text-right relative `,
  introContent,
])

// Mobile "Refine your search" trigger card
export const RefineTrigger = styled.button(() => [
  tw`w-full flex items-center justify-between gap-4 text-left bg-white border border-gray-200 rounded-lg p-4 mt-6 cursor-pointer`,
])

export const RefineTriggerText = styled.span(() => [tw`block`])

export const RefineTitle = styled.span(() => [
  tw`block font-medium text-[#333333] text-base`,
])

export const RefineSubtitle = styled.span(() => [
  tw`block text-gray-500 text-sm mt-1`,
])

// Mobile filter bottom sheet
export const SheetBackdrop = styled.div(() => [
  `background-color: rgba(0,0,0,0.5);`,
  tw`fixed inset-0 z-50`,
])

export const Sheet = styled.div(() => [
  css`
    @keyframes sheetSlideUp {
      from {
        transform: translateY(100%);
      }
      to {
        transform: translateY(0);
      }
    }
    animation: sheetSlideUp 0.25s ease-out;
    max-height: 90vh;
  `,
  tw`fixed left-0 right-0 bottom-0 z-50 flex flex-col bg-white rounded-t-2xl`,
])

// 3-column grid: equal side columns keep the title centred, while the Clear
// button gets its own column so long translations (e.g. German) can't overlap.
export const SheetHeading = styled.div(() => [
  `display: grid; grid-template-columns: 1fr auto 1fr; align-items: center; column-gap: 12px;`,
  tw`text-center font-light text-[#333333] text-lg py-4 px-4 border-b border-gray-200`,
])

export const SheetHeadingTitle = styled.span(() => [
  `grid-column: 2; overflow-wrap: anywhere;`,
])

export const SheetClearLink = styled.button(() => [
  `grid-column: 3; justify-self: end; white-space: nowrap;`,
  `
  :focus {
    outline: 1px dashed #006FCF;
    outline-offset: 2px;
  }
  `,
  tw`text-[#006FCF] text-sm font-normal cursor-pointer`,
])

export const SheetBody = styled.div(() => [
  tw`flex-1 overflow-y-auto px-4 py-4`,
])

export const SheetFooter = styled.div(() => [
  tw`flex items-center justify-center gap-4 px-4 py-4 border-t border-gray-200`,
])

export const SheetCancelButton = styled.button(() => [
  `
  :focus {
    outline: 1px dashed #006FCF;
    outline-offset: 2px;
  }
  `,
  tw`flex-1 text-center text-[#006FCF] font-medium px-6 py-3 cursor-pointer`,
])

export const SheetConfirmButton = styled.button(() => [
  `
  :hover {
    background-color: rgba(0, 111, 207, 0.85);
  }
  :focus {
    outline: 1px dashed #006FCF;
    outline-offset: 3px;
  }
  `,
  tw`flex-1 text-white font-medium bg-[#006FCF] rounded px-6 py-3 cursor-pointer`,
])
